import React from "react"

export default () => (
    <div className="bg-gray-900">
        <div className="px-4 pt-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
            <div className="">
                <div className="grid gap-5 row-gap-8 md:grid-cols-4">
                    <div>
                        <p className="font-medium tracking-wide text-gray-300">About</p>
                        <div className="mt-6 lg:max-w-sm">
                            <p className="text-gray-500">
                                Lands and Surveys Department
                                <br />
                                Ground Floor East,
                                <br />
                                Warrens Office Complex,
                                <br />
                                Warrens, St Michael,
                                <br />
                                Barbados
                            </p>
                        </div>
                    </div>
                    <div>
                        <p className="font-medium tracking-wide text-gray-300">
                            Services
                        </p>
                        <ul className="mt-6 space-y-2">
                            <li>
                                <a
                                    className="text-gray-500 transition-colors duration-300 hover:text-blue-200"
                                    href="/services/surveys"
                                >
                                    Surveying Services
                                </a>
                            </li>
                            <li>
                                <a
                                    className="text-gray-500 transition-colors duration-300 hover:text-blue-200"
                                    href="/services/maps"
                                >
                                    Map Products &amp; Prices
                                </a>
                            </li>
                            <li>
                                <a
                                    className="text-gray-500 transition-colors duration-300 hover:text-blue-200"
                                    href="/services/recording"
                                >
                                    Recording
                                </a>
                            </li>
                            <li>
                                <a
                                    className="text-gray-500 transition-colors duration-300 hover:text-blue-200"
                                    href="/services/graduates"
                                >
                                    Graduate Programme
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-medium tracking-wide text-gray-300">Links</p>
                        <ul className="mt-6 space-y-2">
                            <li>
                                <a
                                    href="https://www.landregistry.gov.bb/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-500 transition-colors duration-300 hover:text-blue-200"
                                >
                                    Land Registry Department
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.townplanning.gov.bb/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-500 transition-colors duration-300 hover:text-blue-200"
                                >
                                    Town Planning Department
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.gov.bb/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-500 transition-colors duration-300 hover:text-blue-200"
                                >
                                    Central Government
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="mt-6 md:mt-0">
                        <p className="font-medium tracking-wide text-gray-300">
                            Help &amp; Support
                        </p>
                        <ul className="mt-6 space-y-2">
                            <li>
                                <a
                                    href="tel:12463102000"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-500 transition-colors duration-300 hover:text-blue-200"
                                >
                                    Phone: (246) 310 2000
                                </a>
                            </li>
                            <li>
                                <span className="text-gray-500 transition-colors duration-300 hover:text-blue-200">
                                    Mon to Fri: 8:30 AM - 4:30 PM
                                </span>
                            </li>
                            <li>
                                <a
                                    href="mailto:lsdept@barbados.gov.bb"
                                    className="text-gray-500 transition-colors duration-300 hover:text-blue-200"
                                >
                                    Email Us: lsdept@barbados.gov.bb
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="flex flex-col justify-between pt-5 pb-10 mt-10 border-t border-gray-800 sm:flex-row">
                <p className="text-sm text-gray-500">
                    © Copyright 2016 - 2021. All rights reserved. Government of Barbados
                </p>
                <ul className="flex items-center mt-6 md:mt-0 mb-3 space-x-6">
                    <li>
                        <a
                            className="text-sm text-gray-500 transition-colors duration-300 hover:text-blue-200"
                            href="/faq"
                        >
                            F.A.Q
                        </a>
                    </li>
                    <li>
                        <a
                            className="text-sm text-gray-500 transition-colors duration-300 hover:text-blue-200"
                            href="/privacypolicy"
                        >
                            Privacy Policy
                        </a>
                    </li>
                    <li>
                        <a
                            className="text-sm text-gray-500 transition-colors duration-300 hover:text-blue-200"
                            href="/termsconditions"
                        >
                            Terms &amp; Conditions
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
)
